export const BenefitsCookie = 'rappi.travel.benefits';
